import React from 'react';
import autoBind from 'auto-bind';
import { Table, Button, Grid, Container } from 'semantic-ui-react';
import { forceActivate } from 'state/activation/actions';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { SemanticToastContainer } from 'react-semantic-toasts';

class ActivationPage extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedFile: null,
    };
    autoBind(this);
  }

  onFileChange(e) {
    const file = e.target.files[0];
    this.setState({ selectedFile: file });
  }

  onFileSubmit() {
    const { selectedFile } = this.state;
    const { dispatch } = this.props;
    if (selectedFile !== null) {
      dispatch(forceActivate(selectedFile));
    }
  }

  render() {
    const { forceActivationResult } = this.props;
    const { selectedFile } = this.state;
    return (
      <>
        <SemanticToastContainer position="top-right" />
        <h1>Force Registration OVO and TCash</h1>
        <br />
        <Container>
          <Grid>
            <Grid.Row>
              <form>
                <input onChange={this.onFileChange} type="file" />
              </form>
            </Grid.Row>
            {selectedFile && (
              <Grid.Row>
                <Button
                  content="Activate"
                  onClick={this.onFileSubmit}
                  primary
                />
              </Grid.Row>
            )}
          </Grid>
        </Container>
        {forceActivationResult.data.length > 0 && (
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>ID</Table.HeaderCell>
                <Table.HeaderCell>Business Name</Table.HeaderCell>
                <Table.HeaderCell>Business Category</Table.HeaderCell>
                <Table.HeaderCell>Payment Code</Table.HeaderCell>
                <Table.HeaderCell>Outlet ID</Table.HeaderCell>
                <Table.HeaderCell>Outlet Name</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Note</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {forceActivationResult.data.map(data => (
                <Table.Row key={data.business_id}>
                  <Table.Cell>{data.business_id}</Table.Cell>
                  <Table.Cell>{data.business_name}</Table.Cell>
                  <Table.Cell>{data.business_category}</Table.Cell>
                  <Table.Cell>{data.payment_method_id}</Table.Cell>
                  <Table.Cell>
                    {data.outlets.map(outlet => (
                      <p key={`outletId-${data.business_id}-${outlet.id}`}>
                        {outlet.id} <br />
                      </p>
                    ))}
                  </Table.Cell>
                  <Table.Cell>
                    {data.outlets.map(outlet => (
                      <p key={`outletName-${data.business_id}-${outlet.id}`}>
                        {outlet.name} <br />
                      </p>
                    ))}
                  </Table.Cell>
                  <Table.Cell>{data.status}</Table.Cell>
                  <Table.Cell>
                    {data.note.map(note => (
                      <p key={`note-${data.business_id}-${Math.random()}`}>
                        {note} <br />
                      </p>
                    ))}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.activation,
});

ActivationPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  forceActivationResult: PropTypes.shape({
    data: PropTypes.array,
  }).isRequired,
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'forceActivate',
  })(ActivationPage)
);
